import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'reactstrap';

export class FAQs extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      faqItems: []
    }
  }

  componentDidMount() {
    document.title = "FAQs :: RAZER";
    this.loadData();
  }

  async loadData() {
    try {
      const response = await fetch("api/faqs/GetAllFaqs");
      if (response.ok) {
        const faqItems = await response.json();
        this.setState({ faqItems, loading: false });
      } else {
        console.log(response.status + ":", response.statusText);
        this.setState({ loading: false });
      }
    } catch (e) {
      console.error(e);
      this.setState({ loading: false });
    }
  }

  toggleAnswer = (id) => {
    const updatedFAQItems = [...this.state.faqItems];
    const index = updatedFAQItems.findIndex(c => c.id === id);
    updatedFAQItems[index].isOpen = !updatedFAQItems[index].isOpen;
    this.setState(updatedFAQItems);
  };

  RenderFAQHeadings(data) {
    //console.log(data);
    const SortedHeadings = [{ id: 0, title: false }, ...data.filter(c => { const sites = JSON.parse(c.sites || "[]"); return c.type === 1 && sites.includes(2); }).sort((a, b) => a.displayOrder - b.displayOrder)];
    return (
      SortedHeadings.map((item, idx) =>
        <span key={idx}>{
          item.title && (
            <>
              <h2>{item.title}</h2>
              {item.copy && <span dangerouslySetInnerHTML={{ __html: item.copy }}></span>}
              <hr />

            </>
          )}
          {this.RenderFAQs(item.id, data)}
        </span>
      )
    )
  }

  RenderFAQs(HeadingId, data) {

    const HeadingQuestion = data.filter(c => { const sites = JSON.parse(c.sites || "[]"); return c.type === 2 && c.parentId === HeadingId && sites.includes(2); }).sort((a, b) => a.displayOrder - b.displayOrder);
    return (
      <ul>{
        HeadingQuestion.map((item, index) =>
          <div className="row p-2" key={index} onClick={() => this.toggleAnswer(item.id)}>
            <strong className="col-10">{item.title}</strong>
            <button className="text-end col-md">
              {item.isOpen ? '-' : '+'}
            </button>
            {item.isOpen && <span dangerouslySetInnerHTML={{ __html: item.copy }}></span>}
          </div>
        )
      }
      </ul>

    )
  }

  render() {

    const content = this.state.loading ? <em>Loading...</em> : this.RenderFAQHeadings(this.state.faqItems);
    return (
      <>
        <div className="background-container" style={{ backgroundColor: 'black', color: 'white' }} >
        </div>

        <nav className="mb-3 crumbs">
          <Link to="/" className="breadcrumb-active text-light"><small>Home</small></Link>
          <span className="breadcrumb-arrow"><i className="fa-solid fa-angle-right"></i></span>
          <small className="breadcrumb-not-active">FAQs</small>
        </nav>
        <div className="container faq">
          <div className="row">
            <div className="col-12">
              <h1 className='mb-3'>FAQs</h1>
              {content}
            </div>
          </div>

        </div>

      </>
    );
  }


}